import React from 'react'
import { TextField } from '@mui/material'
import { useController } from "react-hook-form"

function Input({ control, name, label, placeholder, maxLength }) {
	const {
		field,
		// fieldState: { invalid, isTouched, isDirty },
		// formState: { touchedFields, dirtyFields },
	} = useController({
		name,
		control,
		rules: { required: true },
	})

	return (
		<TextField
			onChange={field.onChange} // send value to hook form
			onBlur={field.onBlur}
			inputRef={field.ref} // send input ref, so we can focus on input when error appear
			value={field.value}
			name={field.name}
			placeholder={placeholder}
			label={label}
			fullWidth
			{...(name === 'message' && { multiline: true, rows: 3 })}
			inputProps={{ maxLength: maxLength }}
			/>
	)
}

export default Input
